export default [
  {
    path: '/',
    meta: {},
    component: () =>
      import(/* webpackChunkName: "adm" */ '../views/layouts/admin'),
    children: [
      {
        path: '/',
        name: 'landing',
        component: () =>
          import(/* webpackChunkName: "landing" */ '../views/layouts/landing'),
        redirect: '/dashboard',
        meta: {},
        children: [
          {
            path: 'dashboard',
            name: 'userDashboard',
            meta: {
              modulName: 'user',
              pageName: 'userDashboard',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-dashboard" */ '../views/user/dashbord'
              ),
          },
          {
            path: 'gaji',
            name: 'userGaji',
            meta: {
              modulName: 'user',
              pageName: 'userGaji',
              pageType: 'view',
            },
            component: () =>
              import(/* webpackChunkName: "user-gaji" */ '../views/user/gaji'),
          },
          {
            path: 'print-slip-gaji/:id?',
            name: 'userPrintSlipGaji',
            meta: {
              modulName: 'user',
              pageName: 'userGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "user-slip-print-gaji" */ '../views/user/gaji/print-slip-gaji'
              ),
          },
          {
            path: 'ijin-cuti',
            name: 'userIjinCuti',
            meta: {
              modulName: 'user',
              pageName: 'ijinCuti',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-ijin-cuti" */ '../views/user/ijin-cuti'
              ),
          },
          {
            path: 'form-ijin-cuti/:id?',
            name: 'userFormIjinCuti',
            meta: {
              modulName: 'user',
              pageName: 'formIjinCuti',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-form-ijin-cuti" */ '../views/user/ijin-cuti/form-ijin'
              ),
          },
          {
            path: 'absensi',
            name: 'userAbsensi',
            meta: {
              modulName: 'user',
              pageName: 'userAbsensi',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-absensi" */ '../views/user/absensi'
              ),
          },
          {
            path: 'lembur',
            name: 'userLembur',
            meta: {
              modulName: 'user',
              pageName: 'userLembur',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-lembur" */ '../views/user/lembur'
              ),
          },
          {
            path: 'form-lembur/:idf?',
            name: 'userFormLembur',
            meta: {
              modulName: 'user',
              pageName: 'formLembur',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-form-lembur" */ '../views/user/lembur/form-lembur'
              ),
          },
          {
            path: 'profile',
            name: 'userProfile',
            meta: {
              modulName: 'user',
              pageName: 'userProfile',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "user-profile" */ '../views/user/profile'
              ),
          },
        ],
      },
      {
        path: 'login',
        name: 'userLogin',
        meta: {
          modulName: 'user',
          pageName: 'login',
          pageType: 'view',
        },
        component: () =>
          import(/* webpackChunkName: "user-login" */ '../views/user/login'),
      },
      {
        path: 'verification/:token?',
        name: 'verification',
        component: () =>
          import(
            /* webpackChunkName: "landing" */ '../views/layouts/verification'
          ),
        meta: {},
      },
      {
        path: 'adm',
        name: 'admin',
        meta: {},
        redirect: '/adm/login',
        component: () =>
          import(/* webpackChunkName: "adm" */ '../views/layouts/main'),
        children: [
          {
            path: 'dashboard',
            name: 'adminDashboard',
            meta: {
              modulName: 'admin',
              pageName: 'dashboard',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-dashboard" */ '../views/admin/dashboard'
              ),
          },
          {
            path: 'pabrik',
            name: 'pabrik',
            meta: {
              modulName: 'admin',
              pageName: 'pabrik',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-pabrik" */ '../views/admin/pabrik'
              ),
          },
          {
            path: 'form-pabrik/:id?',
            name: 'formPabrik',
            meta: {
              modulName: 'admin',
              pageName: 'pabrik',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-pabrik" */ '../views/admin/pabrik/form-pabrik'
              ),
          },
          {
            path: 'dept',
            name: 'dept',
            meta: {
              modulName: 'admin',
              pageName: 'dept',
              pageType: 'view',
            },
            component: () =>
              import(/* webpackChunkName: "opr-dept" */ '../views/admin/dept'),
          },
          {
            path: 'jenisijin',
            name: 'jenisIjin',
            meta: {
              modulName: 'admin',
              pageName: 'jenisIjin',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-jenisijin" */ '../views/admin/jenis-ijin'
              ),
          },
          {
            path: 'print-detail-karyawan/:id?',
            name: 'printDetailKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/karyawan/print-report-detail'
              ),
          },
          {
            path: 'print-karyawan/:id_pabrik?/:id_dept?/:status?',
            name: 'printKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/karyawan/print-report'
              ),
          },
          {
            path: 'karyawan',
            name: 'karyawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-karyawan" */ '../views/admin/karyawan'
              ),
          },
          {
            path: 'form-karyawan/:id?',
            name: 'formKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'karyawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-karyawan" */ '../views/admin/karyawan/form-karyawan'
              ),
          },
          {
            path:
              'print-ijin/:id_karyawan?/:id_pabrik?/:id_dept?/:tgl_awal?/:tgl_akhir?/:status?',
            name: 'printIjin',
            meta: {
              modulName: 'admin',
              pageName: 'ijinKaryawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/ijin-karyawan/print-report'
              ),
          },
          {
            path: 'ijin',
            name: 'ijinKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'ijinKaryawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-ijin-karyawan" */ '../views/admin/ijin-karyawan'
              ),
          },
          {
            path: 'form-ijin/:id?',
            name: 'formIjinKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'ijinKaryawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-ijin-karyawan" */ '../views/admin/ijin-karyawan/form-karyawan'
              ),
          },
          {
            path:
              'print-absensi/:id_karyawan?/:id_pabrik?/:id_dept?/:tgl_awal?/:tgl_akhir?/:status?',
            name: 'printAbsensi',
            meta: {
              modulName: 'admin',
              pageName: 'absensiKaryawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/absensi/print-report'
              ),
          },
          {
            path: 'absensi',
            name: 'absensiKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'absensiKaryawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-absensi-karyawan" */ '../views/admin/absensi'
              ),
          },
          {
            path: 'form-absensi/:id?',
            name: 'formAbsensiKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'absensiKaryawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-absensi-karyawan" */ '../views/admin/absensi/form-absensi'
              ),
          },
          {
            path:
              'print-lembur/:id_karyawan?/:id_pabrik?/:id_dept?/:tgl_awal?/:tgl_akhir?/:status?',
            name: 'printLembur',
            meta: {
              modulName: 'admin',
              pageName: 'lemburKaryawan',
              pageType: 'view',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-print-karyawan" */ '../views/admin/lembur-karyawan/print-report'
              ),
          },
          {
            path: 'lembur',
            name: 'lemburKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'lemburKaryawan',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-lembur-karyawan" */ '../views/admin/lembur-karyawan'
              ),
          },
          {
            path: 'form-lembur/:id?',
            name: 'formLemburKaryawan',
            meta: {
              modulName: 'admin',
              pageName: 'lemburKaryawan',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-lembur-karyawan" */ '../views/admin/lembur-karyawan/form-karyawan'
              ),
          },
          {
            path: 'slip-gaji',
            name: 'slipGaji',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-gaji" */ '../views/admin/slip-gaji'
              ),
          },
          {
            path: 'slip-gaji/detail/:id_slip_periode',
            name: 'slipGajiPeriode',
            meta: {
              modulName: 'admin',
              pageName: 'slipGajiPeriode',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-gaji-periode" */ '../views/admin/slip-gaji/detail-slip'
              ),
          },
          {
            path: 'print-all-slip/:id_slip_periode?/:id_karyawan?/:id_dept?',
            name: 'printAllSlipGaji',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-print-gaji" */ '../views/admin/slip-gaji/print-report'
              ),
          },
          {
            path: 'print-slip-periode/:periode?/:id_pabrik?/:status?',
            name: 'printAllSlipPeriode',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-print-gaji" */ '../views/admin/slip-gaji/print-report-periode'
              ),
          },
          {
            path: 'print-slip-gaji/:id?',
            name: 'printSlipGaji',
            meta: {
              modulName: 'admin',
              pageName: 'slipGaji',
              pageType: 'print',
              printReport: true,
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-slip-print-gaji" */ '../views/admin/slip-gaji/print-slip-gaji'
              ),
          },
          {
            path: 'komponen-gaji',
            name: 'kompGaji',
            meta: {
              modulName: 'admin',
              pageName: 'kompGaji',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-komp-gaji" */ '../views/admin/komponen-gaji'
              ),
          },
          {
            path: 'administrator',
            name: 'administrator',
            meta: {
              modulName: 'admin',
              pageName: 'administrator',
              pageType: 'view',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-administrator" */ '../views/admin/administrator'
              ),
          },
          {
            path: 'form-administrator/:id?',
            name: 'formAdministrator',
            meta: {
              modulName: 'admin',
              pageName: 'administrator',
              pageType: 'create_update',
            },
            component: () =>
              import(
                /* webpackChunkName: "opr-form-administrator" */ '../views/admin/administrator/form-administrator'
              ),
          },
          {
            path: 'login',
            name: 'login',
            component: () =>
              import(/* webpackChunkName: "login" */ '../views/account/login'),
            meta: {
              printReport: true,
            },
          },
          {
            path: 'forgot-password',
            name: 'ForgotPassword',
            component: () =>
              import(
                /* webpackChunkName: "forgot" */ '../views/account/forgot-password'
              ),
            meta: {
              printReport: true,
            },
          },
          {
            path: 'profile',
            name: 'ProfileAdmin',
            component: () =>
              import(
                /* webpackChunkName: "profile-admin" */ '../views/account/profile'
              ),
            meta: {},
          },
        ],
      },
      // {
      //   path: '/usr',
      //   name: 'user',
      //   meta: {},
      //   component: () =>
      //     import(/* webpackChunkName: "user" */ '../views/layouts/user'),
      //   redirect: '/',
      //   children: [
      //     {
      //       path: 'dashboard',
      //       name: 'userDashboard',
      //       meta: {},
      //       component: () =>
      //         import(
      //           /* webpackChunkName: "user-dashboard" */ '../views/user/user-dashboard'
      //         ),
      //       children: [],
      //     },
      //   ],
      // },
    ],
  },
  {
    path: '*',
    name: 'NotFound',
    component: () =>
      import(/* webpackChunkName: "forgot" */ '../views/layouts/notfound'),
  },
];
